import React, { Component, ReactNode } from "react";
import classnames from "classnames";

import * as styles from "./Details.scss";

export interface IDetailEntry {
    label: string;
    help?: ReactNode;
    content: ReactNode;
}

export interface IDetailsProps {
    entries: IDetailEntry[];
    className?: string;
}

export class Details extends Component<IDetailsProps> {
    public render() {
        const { entries, className } = this.props;

        return (
            <div className={classnames(styles.details, className)}>
                {entries.map(({ label, help, content }) => (
                    <div key={label} className={styles.entry}>
                        <div className={styles.label}>
                            {label}
                            {help && (
                                <span className={styles.help}>{help}</span>
                            )}
                        </div>
                        <div className={styles.value}>{content}</div>
                    </div>
                ))}
            </div>
        );
    }
}
